import { render, staticRenderFns } from "./EhrStudentSubmit.vue?vue&type=template&id=2158058d&scoped=true&lang=pug"
import script from "./EhrStudentSubmit.vue?vue&type=script&lang=js"
export * from "./EhrStudentSubmit.vue?vue&type=script&lang=js"
import style0 from "./EhrStudentSubmit.vue?vue&type=style&index=0&id=2158058d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158058d",
  null
  
)

export default component.exports